
import { Vue, Component, Prop } from "vue-property-decorator";
import { v4 as uuid } from "uuid"

import GET_EDUCATIONS from "@/apollo/profile/educations/GetEducations.gql";
import CREATE_USER_EDUCATION from "@/apollo/profile/educations/CreateEducation.gql";

import ProfileEducationCard from "@/components/profile/educations/ProfileEducationCard.vue";
import EducationModal from "@/components/profile/educations/EducationModal.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { User_Education } from "@/generated/graphql";
import UserResume from "@/entities/UserResume";

@Component({
  components: {
    ProfileEducationCard,
    EducationModal,
    UIButton,
    FormWrapper,
    LoadingOverlay,
  },
  apollo: {
    educations: {
      query: GET_EDUCATIONS,
      variables() {
        return {
          id: this.userId,
        };
      },
      update: (data) => {
        return data.user_by_pk.educations;
      },
    },
  },
})
export default class ProfileEducation extends Vue {
  @Prop({ type: String, required: true }) readonly userId!: string;

  educations?: User_Education[] = undefined;

  isModalOpen: boolean = false;

  showModal(): void {
    this.isModalOpen = true;
  }

  refresh(): void {
    this.$apollo.queries.educations.refetch();
    this.$emit("update");
  }

      /**
     * ==========================[qtrinh@ideatheorem.com]==========================
     * Add experience here
     */
     created() {
      this.$eventBus.listen(UserResume.UPDATE_RESUME, (data: any) => {
        const scrappedResume = data.data
        if (scrappedResume)
        {
          if (scrappedResume.hasOwnProperty("education") && scrappedResume.education && scrappedResume.education.length > 0)
          {

            scrappedResume.education.map( async (edu) =>
            {
              const educationId = uuid();
              let education: User_Education = {
                id: educationId,
                user_id: this.userId,
                title: edu.accreditation?.education,
                institution: edu.organization,
                start_date: edu.dates?.startDate,
                end_date: edu.dates?.completionDate,
                summary: edu.summary,
                added_by_id: this.userId,
                user: null
              }

              this.educations.push(education)

              await this.$apollo.mutate({
                mutation: CREATE_USER_EDUCATION,
                variables: {
                  educationSet: {
                    ...{
                      user_id: this.userId,
                      title: edu.accreditation?.education,
                      institution: edu.organization,
                      start_date: edu.dates?.startDate,
                      end_date: edu.dates?.completionDate,
                      summary: edu.summary
                    }
                  },
                },
              });
            })
          }
        }
      })
    }

    beforeDestroy() {
      this.$eventBus.remove(UserResume.UPDATE_RESUME)
    }
    /**
     * ==========================[qtrinh@ideatheorem.com]==========================
     */
}
